import { GET_SELECT_REP_LIST_REQUEST } from '../actions/users';

const initialState = {
  selectRepList: [],
  currentPage: 0,
  pageCount: 0,
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_SELECT_REP_LIST_REQUEST.SUCCESS: {
      const { currentPage, pageCount } = payload.data.data._meta;

      if (currentPage === 1) {
        return {
          ...state,
          selectRepList: payload.data.data.response,
          currentPage,
          pageCount,
        };
      }

      return {
        ...state,
        selectRepList: [...state.selectRepList, ...payload.data.data.response],
        currentPage,
        pageCount,
      };
    }

    default:
      return state;
  }
};

export default reducer;
